import useTranslation from "next-translate/useTranslation"
import { useRef, useState } from "react"
import { Tooltip } from "reactstrap"

import { ImplementationState, IProject, ProjectProgress } from "@api/schema"
import Icon, { IconName } from "@components/common/Icon"

interface IProps {
  arialabel?: string
  className?: string
  project: IProject
  size?: number
}

/**
 * This component provides an Icon depending on the current progress and implementation state
 * of the given project
 */
const ProjectImplementationStateIcon: React.FC<IProps> = (props: IProps) => {
  const {
    arialabel,
    className = "project-implementation-state__icon",
    project,
    size = 25,
  } = props
  const { t } = useTranslation("common")

  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen)
  }


  // reference to to the tooltip target, initially null => needed to make sure, that the tooltip is rendered after the tooltip targets are mounted
  const tooltipTargetRef = useRef(null)

  let icon: IconName
  let title: string
  if (project.progress === ProjectProgress.Idea) {
    icon = "light-bulb"
    title = t("project.progress.idea")
  } else {
    title = t("project.implementationState." + project.implementationState)
    switch (project.implementationState) {
      case ImplementationState.Planning:
        icon = "project"
        break
      case ImplementationState.Running:
        icon = "project-implementation"
        break
      case ImplementationState.Finished:
        icon = "check"
        break
    }
  }


  return <>
    <Icon aria-label={arialabel} className={className} iconRef={tooltipTargetRef} name={icon} size={size} title={title} />
    {/* if a tooltiptext is not empty and if the tooltip target is only mounted, render the the tooltip */}
    {tooltipTargetRef?.current && (
      <Tooltip
        isOpen={tooltipOpen}
        target={tooltipTargetRef.current}
        toggle={toggleTooltip}
      >
        {title}
      </Tooltip>
    )}
  </>
}

export default ProjectImplementationStateIcon
